module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_online@3x-4f858f736b3344e398a25f2f03c70b40.webp";